import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ClientIntegrationType } from '../interfaces/client-integration-type';

@Injectable({
    providedIn: 'root',
})
export class ClientIntegrationTypeService {
    private serverUrl = 'https://' + window.location.host; // TODO Get url and version number from appsettings.
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/ClientIntegrationType/').replace(
        '{version}',
        this.version
    );

    constructor(private _http: HttpClient) {}

    getClientIntegrationTypes(): Observable<ClientIntegrationType[]> {
        return this._http.get<ClientIntegrationType[]>(this._url + 'GetClientIntegrationTypes');
    }
}
